import { render, staticRenderFns } from "./ReviewTicktesOld.vue?vue&type=template&id=0055b120&scoped=true"
import script from "./ReviewTicktesOld.vue?vue&type=script&lang=js"
export * from "./ReviewTicktesOld.vue?vue&type=script&lang=js"
import style0 from "./ReviewTicktesOld.vue?vue&type=style&index=0&id=0055b120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055b120",
  null
  
)

export default component.exports